<template>
	<v-tooltip v-bind="$attrs" v-on="$listeners" :disabled="$attrs.disabled || $vuetify.breakpoint.mdAndDown">
		<!-- Forward all named slots -->
		<slot v-for="slot of Object.keys($slots)" :name="slot" :slot="slot" />
		<!-- Forward all scoped slots -->
		<template v-for="slot of Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
			<slot :name="slot" v-bind="scope" />
		</template>
	</v-tooltip>
</template>
<script>
export default {
	name: 'LTooltip',
};
</script>
